// Last-cooked lookup for the weekly planner's "forgotten recipe"
// signal. One scoped two-column query, reduced client-side to a
// Map(recipe_slug → most recent cooked_at ms). Cached 60 min — the
// planner is the only consumer and staleness of an hour is invisible
// at "you haven't made this in 2 months" granularity.

import { supabase } from "./supabase";
import { readCache, writeCache } from "./useCachedQuery";

const TTL_MS = 60 * 60 * 1000;

export async function fetchLastCookedMap(userId) {
  if (!userId) return new Map();
  const cacheKey = `lastCooked:v1:${userId}`;

  const cached = readCache(cacheKey, TTL_MS);
  if (cached && typeof cached === "object") {
    return new Map(Object.entries(cached));
  }

  const { data, error } = await supabase
    .from("cook_logs")
    .select("recipe_slug, cooked_at")
    .eq("user_id", userId);
  if (error) {
    console.warn("[lastCooked] fetch failed:", error.message);
    return new Map();
  }

  const map = new Map();
  for (const row of data || []) {
    if (!row?.recipe_slug || !row?.cooked_at) continue;
    const t = new Date(row.cooked_at).getTime();
    if (!Number.isFinite(t)) continue;
    const prev = map.get(row.recipe_slug);
    if (prev == null || t > prev) map.set(row.recipe_slug, t);
  }

  writeCache(cacheKey, Object.fromEntries(map));
  return map;
}
